import React from 'react';
import { FaBars } from 'react-icons/fa';
import '../styles/Header.css';

const Header = ({ setMenuOpen }) => {
  return (
    <header className="header-container">
      <button className="hamburger-icon" onClick={() => setMenuOpen((prev) => !prev)}>
        <FaBars />
      </button>
      <h1 className="header-title">Kammaṭṭhānasamuṭṭhāpaka Nikāya</h1>
    </header>
  );
};

export default Header;
